"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsolateMain = exports.IsolateHeader = exports.Isolate = void 0;
var isolate_1 = require("./isolate");
Object.defineProperty(exports, "Isolate", { enumerable: true, get: function () { return __importDefault(isolate_1).default; } });
var isolate_header_1 = require("./isolate.header");
Object.defineProperty(exports, "IsolateHeader", { enumerable: true, get: function () { return __importDefault(isolate_header_1).default; } });
var isolate_main_1 = require("./isolate.main");
Object.defineProperty(exports, "IsolateMain", { enumerable: true, get: function () { return __importDefault(isolate_main_1).default; } });
//# sourceMappingURL=index.js.map